import { createAsyncThunk } from "@reduxjs/toolkit";
import { message } from "components";
import { getApi, postApi } from "lib";
import {
  CREATE_PACKAGE,
  CUSTOM_PACKAGE_LIST,
  PACKAGE,
  SERVICE_TYPE,
  SERVICE_TYPES,
  ALLPACKAGE,
} from "services";
import { API_ERROR } from "utils/constant";


export const getPackageList = createAsyncThunk(
  "package/getPackageList",
  async (payload, thunkAPI) => {
    try {
      // Accepts either a bare service-type id or { id, page }.
      const { id, page } =
        payload && typeof payload === "object" ? payload : { id: payload };
      const response = await getApi(`${PACKAGE}${id ?? ""}${page > 1 ? `&page=${page}` : ""}`);
      return {
        packages: response?.data?.data?.packages || [],
        pagination: response?.data?.data?.pagination || null,
      };
    } catch (error) {
      message.error(error?.response?.data?.message || API_ERROR);
      return thunkAPI.rejectWithValue(error.response.data.message);
    }
  }
);

export const getallpackagelist = createAsyncThunk(
  "package/getallpackagelist",
  async (thunkAPI) => {
    try {
      const response = await getApi(ALLPACKAGE);
      return response?.data?.data;
    } catch (error) {
      message.error(error?.response?.data?.message || API_ERROR);
      return thunkAPI.rejectWithValue(error.response.data.message);
    }
  }
);

export const getCustomPackageList = createAsyncThunk(
  "package/getCustomPackageList",
  async (payload, thunkAPI) => {
    try {
      const response = await getApi(CUSTOM_PACKAGE_LIST);
      return response?.data?.data ?? response?.data;
    } catch (error) {
      message.error(error?.response?.data?.message || API_ERROR);
      return thunkAPI.rejectWithValue(error.response.data.message);
    }
  }
);

export const postPackage = createAsyncThunk(
  "package/postPackage",
  async ({ body, next = () => { } }, thunkAPI) => {
    try {
      const response = await postApi(CREATE_PACKAGE, body);
      if (response?.data?.success) {
        message.success(response?.data?.message);
        next(response?.data?.data);
      }
    } catch (error) {
      message.error(error?.response?.data?.message || API_ERROR);
      return thunkAPI.rejectWithValue(error.response.data.message);
    }
  }
);

// ===============================================================

export const getServicesTypes = createAsyncThunk(
  "package/getServicesTypes",
  async (payload, thunkAPI) => {
    try {
      const response = await getApi(SERVICE_TYPES);
      return response?.data?.data;
    } catch (error) {
      message.error(error?.response?.data?.message || API_ERROR);
      return thunkAPI.rejectWithValue(error.response.data.message);
    }
  }
);

export const getServicesTypeById = createAsyncThunk(
  "packages/getServicesTypeById",
  async (payload, thunkAPI) => {
    try {
      const response = await getApi(SERVICE_TYPE + payload);
      return response?.data?.data;
    } catch (error) {
      message.error(error?.response?.data?.message || API_ERROR);
      return thunkAPI.rejectWithValue(error.response.data.message);
    }
  }
);
